import { api } from './client';

export interface WarehouseItem {
  id: string;
  legacyId: number | null;
  name: string;
  typeId: number | null;
  comment: string | null;
  quantity: string | null;
  barcode: string;
  isInOffice: boolean;
  assignedToId: string | null;
  assignedToName: string | null;
  clientId: number | null;
  clientName: string | null;
  isWorkUnit: boolean;
  legacyUserlistId: number | null;
  legacyHolderName: string | null;
  legacyHolderLogin: string | null;
  legacyLastChange: string | null;
  legacyLog: string | null;
  importedAt: string | null;
  createdAt: string;
  updatedAt: string;
  isMine?: boolean;
}

export interface WarehouseGroupedResponse {
  my: WarehouseItem[];
  available: WarehouseItem[];
  others: WarehouseItem[];
}

export interface WarehousePayload {
  name: string;
  barcode: string;
  typeId?: number | null;
  comment?: string | null;
  quantity?: string | null;
  isInOffice?: boolean;
  assignedToId?: string | null;
  clientId?: number | null;
  clientName?: string | null;
  isWorkUnit?: boolean;
}

export interface WarehouseAuditLog {
  id: string;
  action: 'CREATE' | 'UPDATE' | 'DELETE';
  modelName: string;
  recordId: string;
  userId: string | null;
  userName: string | null;
  dataBefore: Record<string, unknown> | null;
  dataAfter: Record<string, unknown> | null;
  diff: Record<string, { old: unknown; new: unknown }> | null;
  ip: string | null;
  userAgent: string | null;
  createdAt: string;
}

export const warehouseApi = {
  getGrouped: async (): Promise<WarehouseGroupedResponse> => {
    const { data } = await api.get('/warehouse/mobile');
    return data;
  },

  getByClient: async (clientId: number): Promise<{ items: WarehouseItem[]; total: number }> => {
    const { data } = await api.get(`/warehouse/client/${clientId}`);
    return data;
  },

  getHistory: async (id: string): Promise<{ items: WarehouseAuditLog[]; total: number }> => {
    const { data } = await api.get(`/warehouse/${id}/history`);
    return data;
  },

  create: async (body: WarehousePayload): Promise<WarehouseItem> => {
    const { data } = await api.post('/warehouse', body);
    return data;
  },

  takeForClient: async (
    id: string,
    body: { clientId?: number; clientName?: string },
  ): Promise<WarehouseItem> => {
    const { data } = await api.post(`/warehouse/${id}/take-client`, body);
    return data;
  },

  takeForSelf: async (id: string): Promise<WarehouseItem> => {
    const { data } = await api.post(`/warehouse/${id}/take-self`);
    return data;
  },

  returnToOffice: async (id: string): Promise<WarehouseItem> => {
    const { data } = await api.post(`/warehouse/${id}/return`);
    return data;
  },
};
